import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QueryString from 'query-string';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import BasicInfo from '../Common/BasicInfo';
import * as Steps from './steps';
import { getSessionStorageItem, setSessionStorageItem, SESSION_STORAGE_DISABILITY_KEY } from '../../../sessionStorage';
import { saveSessionEvent } from '../../../session';

import '../Quoter.scss';
import './Ameritas.scss';

export default function Ameritas(props) {

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => { saveSessionEvent(); }, [location]);

  const { path } = useParams();
  const SESSION_STORAGE_KEY = 'AMERITAS_ADI';

  const prefill = location && location.search && location.search.toLowerCase().includes('prefill');
  const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_KEY);
  const sessionStorageBasicInfo = getSessionStorageItem(SESSION_STORAGE_DISABILITY_KEY);
  const basicInfo = sessionStorageBasicInfo ? sessionStorageBasicInfo.pages.basicInfo : BasicInfo.DefaultFormState(prefill);

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 1;
  }

  const specs = {
    age: { min: 18, max: 60 },
    coverageAmount: { min: 25000, max: 100000 },
  };

  const newFormState = {
    currentStep: 1,
    pages: {
      quoter: Steps.Quoter.DefaultFormState(prefill),
    },
  };

  const getHeaderText = () => {
    const currentStep = formState.currentStep;
    if (currentStep === 1) {
      return "Let's get the best quote for you";
    } else {
      return 'DInamic Fundamental&#174 Disability Income Insurance';
    }
  };

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // Update the formState when the url path changes the step
  useEffect(() => {
    if (!path) {
      return;
    }

    const nextStep = steps.find((s) => s.path === path);

    if (!nextStep) {
      return;
    }

    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path]);

  const onNext = () => {
    const nextStep = steps.find((s) => s.step === formState.currentStep + 1);

    if (!nextStep) {
      throw new Error('onNext did not find a next step');
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    navigate(`/quote/disability/ameritas-dinamic-Fundamental/${nextStep.path}`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    const backStep = steps.find((s) => s.step === formState.currentStep - 1);
    if (!backStep) {
      navigate(`/landing/disability-income`);
      return
    }

    const newFormState = { ...formState, currentStep: backStep.step };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    navigate(`/quote/disability/ameritas-dinamic-Fundamental/${backStep.path}`);
    window.scroll(0, 0);
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  };

  const steps = [
    {
      step: 1,
      path: 'get-a-quote',
      progressTitle: 'Get a Quote',
      component: (
        <Steps.Quoter
          formState={formState.pages.quoter}
          basicInfo={basicInfo}
          onFieldChange={(field, value) => onFieldChange('quoter', field, value)}
          onNext={onNext}
          onBack={onBack}
          queryString={location ? QueryString.parse(location.search) : null}
          coverageAmountSpecs={specs.coverageAmount}
        />
      ),
      hideProgressTracker: true,
    },
  ];

  const currentStepObj = steps.find((s) => s.step === formState.currentStep) || steps[0];

  return (
    <div>
      <Helmet>
        <title>{`Ameritas - Get a Quote`}</title>
      </Helmet>
      <HeaderStepper
        title={getHeaderText()}
        hidden={props.landing}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        stepName={currentStepObj.progressTitle}
        step={formState.currentStep}
        totalSteps={steps.length - 8}
      >
        <div className="ameritas">{currentStepObj.component}</div>
      </HeaderStepper>
    </div>
  );
}
